import { useTranslation } from 'react-i18next';

export const useLocaleText = () => {
  const { t } = useTranslation();

  return {
    toolbarFilters: t('filter.filters'),
    toolbarExport: t('filter.export'),
    toolbarColumns: t('filter.columns'),
    toolbarDensity: t('filter.density'),
    columnsPanelHideAllButton: t('filter.hideAll'),
    columnsPanelShowAllButton: t('filter.showAll'),
    columnsPanelTextFieldPlaceholder: t('filter.nameColumns'),
    columnsPanelTextFieldLabel: t('filter.searchColumns'),
    filterPanelColumns: t('filter.column'),
    filterPanelInputLabel: t('filter.value'),
    filterPanelInputPlaceholder: t('filter.valueFilter'),
    filterPanelOperators: t('filter.operator'),
    filterOperatorEquals: t('filter.equals'),
    filterOperatorContains: t('filter.contains'),
    filterOperatorStartsWith: t('filter.startsWith'),
    filterOperatorEndsWith: t('filter.endsWith'),
    filterOperatorIsEmpty: t('filter.isEmpty'),
    filterOperatorIsNotEmpty: t('filter.isNotEmpty'),
    filterOperatorIsAnyOf: t('filter.isAnyOf'),
    toolbarDensityComfortable: t('filter.comfortable'),
    toolbarDensityStandard: t('filter.standard'),
    toolbarDensityCompacte: t('filter.compact'),
    toolbarExportCSV: t('filter.exportCSV'),
    toolbarExportPrint: t('filter.print'),
    noRowsLabel: t('pagination.noRowsLabel'),
    toolbarDensityLabel: t('pagination.toolbarDensityLabel'),
    toolbarDensityCompact: t('pagination.toolbarDensityCompact'),
    toolbarColumnsLabel: t('pagination.toolbarColumnsLabel'),
    toolbarFiltersLabel: t('pagination.toolbarFiltersLabel'),
    toolbarExportLabel: t('pagination.toolbarExportLabel'),
    footerRowSelected: (count) => t('pagination.footerRowSelected', { count }),
    footerTotalRows: t('pagination.footerTotalRows'),
    footerPaginationRowsPerPage: t('pagination.footerPaginationRowsPerPage'),
    footerPaginationOf: t('pagination.footerPaginationOf'),
    columnMenuSortAsc: t('pagination.columnMenuSortAsc'),
    columnMenuSortDesc: t('pagination.columnMenuSortDesc'),
    columnMenuFilter: t('pagination.columnMenuFilter'),
    columnMenuHideColumn: t('pagination.columnMenuHideColumn'),
    columnMenuShowColumns: t('pagination.columnMenuShowColumns')
  };
};
